import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

import { aiAgentTaskPath } from './aiAgentTasksPath';
import { AIAgentTaskDetail } from './types';

const useAIAgentTaskShow = (
  params: { appSlug: string; taskId: string },
  opts?: UseMonolithApiQueryOptions<AIAgentTaskDetail, never>,
) =>
  useMonolithApiQuery<AIAgentTaskDetail, never>(
    ['ai_agent_tasks', params.appSlug, params.taskId],
    aiAgentTaskPath(params),
    opts,
  );

export default useAIAgentTaskShow;
